export default {
  computed: {
    dialogUser() {
      const members = this.dialog.members
      const authId = this.$auth.user()?.id
      if (members?.length) {
        const user = members.find(({ id }) => id !== authId)
        if (user) {
          return user
        }
        else {
          return members[0];
        }
      }
      return {}
    },
    dialogTitle() {
      if(this.isGroupChat) {
        return this.dialog.title;
      }
      else {
        const user = this.dialogUser;
        if(user?.id) {
          return `${this.$localized(user.localized_name, user.first_name)} ${this.$localized(user.localized_surname, user.last_name)}`
        }
        else {
          return this.dialog.title;
        }
      }
    },
    dialogAvatar() {
      if (this.isGroupChat) {
        return this.dialog.avatar
      } else {
        return this.dialogUser.avatar
      }
    },
    isGroupChat() {
      return [1, 3].includes(this.dialog.type.id)
    },
  },
}
